import React from 'react'
import picturfour from '../../assets/imgs/newrender.mp4'
import {CommandDialogDemo} from '../../components/CommandDialogDemo'
import {BentoDemoStack} from '../../components/BentoDemoStack'

const Fiveproject =() => {
  return (
    <React.Fragment>
      <article className='nextra-body relative pb-8 w-full max-w-full flex min-w-0 pr-[calc(env(safe-area-inset-right)-1.5rem)] nextra-body-typesetting-default'>
           <main className='changeame mx-auto max-w-4xl px-6 md:px-8 pt-4 z-10 min-w-0 w-full'>
             <div className='nextra-breadcrumb text-sm font-normal flex mt-2.5 text-gray-500 transition-colors cursor-default overflow-hidden'>
               <div className='transition-colors hover:text-gray-900 dark:hover:text-gray-200 text-ellipsis whitespace-nowrap overflow-hidden min-w-[24px]'>
                 All Articles
               </div>
               <span className='mx-2 select-none'>/</span>
               <div className='transition-colors hover:text-gray-900 dark:hover:text-gray-200 text-gray-600 dark:text-gray-400 active'>
                 UX-Design
               </div>
             </div>
           <h1>The importance of UI Design in eCommerce!!</h1>
             <div className="w-auto px-2 pt-16 mx-auto sm:pt-24 lg:px-8">
               <div className="w-auto grid grid-cols-1">
                 <BentoDemoStack />
               </div>
             </div>
             <h2>
               <span className="subheading-anchor" id="DesignUX"></span>
               <a href="#DesignUX" className="anchor text-current no-underline no-outline">Design<span className="anchor-icon" aria-hidden="true">#</span></a>
             </h2>
             <p>
             A fabulous website is necessary for businesses to grow in the modern era. In a nutshell, your website is the face of your business, and thus it is essential to design a website neatly. It will not be an overstatement to say that customers are reluctant these days to trust a business that doesn't have a website.Having an online presence either through a website or a mobile app is important as they give a transparent medium for the customers to buy things directly. As far as running an ecommerce business is concerned, having the design and development process successfully completed by a top ecommerce development company is a necessity.The online ecommerce platform needs to have captivating aesthetics that keep the customers hooked to the ecommerce website & ecommerce app, and increase the ecommerce business's revenue.The term UI/UX design was first coined in the late 1990s by cognitive psychologist Donald Norman. Moreover, ever since the proliferation of the ecommerce industry, the importance of UI has increased manifold. Thus having a beautiful UI for a successful ecommerce business is necessary.This blog will study the nuances of user interface <code>UI</code> and their overall impact on the eCommerce business. In addition, we will also see the approach and steps to create an emphatic UI design for your eCommerce app or website. 
             <h4>What is an eCommerce UI?</h4>
             <h5>Key elements of eCommerce UI Design!</h5>
             Having a balanced ecommerce UI design is a key aspect to garner more organic traffic to your ecommerce platform. The UI designers have to maintain a fine blend of intuitiveness, functionality, and beauty in the UI design of the ecommerce app or website. Here are the five key elements in making the ecommerce platform more engaging and reliable.
             On the other hand, Having a proper search box is very important as it is highly likely to convert your leads into customers. But if the search bar doesn't work properly, the visitors won't get their desired information and will leave the ecommerce website unsatisfied.
             </p>
             <br></br>
           <h1>User Experience Design</h1>
             <h2>
               <span className="subheading-anchor" id="Visuals"></span>
               <a href="#Visuals" className="anchor text-current no-underline no-outline">High-quality visuals<span className="anchor-icon" aria-hidden="true">#</span></a>
             </h2>
             <p>
             The user experience design has to be user-friendly for the ecommerce platform as it is vital to keep the user engagement rates high. So, always put the users in focus first and then prioritize the functionality above everything else.You need to understand that not each of your targeted customers is tech-savvy. Thus, always make the UX design as intuitive as possible. Do not complicate things for the visitors with complicated design solutions.Here are the best practices to create a simple UX design for eCommerce app and websites:
             <li>Simplify the ecommerce UI design </li>
              <li>The web pages and app screens must load quickly. Keep a check on that</li>
              <li>Image zooming with double-tap gesture must be there</li>
              <li>Always look to analyze and test the user behavior for future references</li>
             </p>
            <div className='hidden ...'>
             <CommandDialogDemo />
            </div>
            <div className="w-auto px-2 pt-16 pb-8 mx-auto sm:pt-24 lg:px-8">
              <div className="top-10 [--duration:20s] [mask-image:linear-gradient(to_top,transparent_20%,#000_100%)] ">
                <video src={picturfour} alt='video/mp4' className='will-change' autoPlay='autoplay' loop='loop' muted='muted' playsInline='playsinline' height='500' width='800' style={{position:'relative'}}/>
              </div>
             </div>
             <div className='mt-16'></div>
             <div
               className='nextra-navigation-links pt-8 mb-8 border-t dark:border-neutral-800 flex flex-row items-center justify-between'
             >
               <div className='flex-1 min-w-0'></div>
               <div className='flex-1 min-w-0 text-right'>
                 <a
                   className='w-full text-lg font-medium p-4 -m-4 no-underline transition-colors text-gray-600 dark:text-gray-300 dark:hover:text-primary-500 hover:text-primary-500 inline-flex items-center justify-end rounded ml-2'
                   title='Next'
                   href='/performance'
                   > Performance <svg
                     fill='none'
                     viewBox='0 0 24 24'
                     stroke='currentColor'
                     height='24'
                     className='transform inline flex-shrink-0 ml-1'
                   >
                     <path
                       stroke-linecap='round'
                       stroke-linejoin='round'
                       stroke-width='2'
                       d='M9 5l7 7-7 7'
                     ></path></svg></a>
               </div>
             </div>
           </main>
           <div className='nextra-toc w-64 hidden xl:block text-sm px-4'>
             <div
               className='nextra-toc-content overflow-y-auto pr-4 -mr-4 sticky max-h-[calc(100vh-4rem-env(safe-area-inset-bottom))] top-16 pt-8'
             >
               <ul>
                 <p className='font-semibold tracking-tight mb-4'>
                   On This Page
                 </p>
                 <li className='scroll-py-6 scroll-my-6'>
                   <a
                     href='#DesignUX'
                     className='no-underline inline-block font-semibold text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-300'
                     >UX Design</a>
                 </li>
                 <li className='scroll-py-6 scroll-my-6'>
                   <a
                     href='#Visuals'
                     className='no-underline inline-block font-semibold text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-300'
                     >High Visuals</a>
                 </li>
               </ul>
               <div className='nextra-toc-meta border-t mt-8 pt-8 shadow-[0_-12px_16px_white] dark:shadow-[0_-12px_16px_#111] bg-white dark:bg-dark sticky pb-8 bottom-0 dark:border-neutral-800'> 
               </div>
               </div>
             </div>
        </article>
    </React.Fragment>
  )
}

export default Fiveproject
